import React from 'react'
import ModalFormUI from '../../../widgets/form/ModalFormUI'
import InputSelectSF from '../../../widgets/form/InputSelectSF'

const ChatMessageStatusModalUI = ({
  context, successMsg, errorList, setErrorList,
  updateMode, submitted, onSubmit, onCancelClick,
  status, onStatusChange, statusError, setStatusError, statusList
}) =>
  <ModalFormUI
    context={context}
    titleLabel='Update status'
    buttonLabel='Send'
    cancelLabel='Cancel'
    isOpen={updateMode}
    onRequestClose={onCancelClick}
    successMsg={successMsg}
    errorList={errorList}
    setErrorList={setErrorList}
    onSubmit={onSubmit}
    busy={submitted}
  >
    <InputSelectSF type='select' name='status' label='Status'
      value={status} onChange={onStatusChange} optionList={statusList}
      error={statusError} setError={setStatusError}
    />
  </ModalFormUI>

export default ChatMessageStatusModalUI
